module.exports = __webpack_public_path__ + "static/media/tree_delete_icon.e112757b.svg";